import React from "react";

function NoMessages() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100%"
      data-name="Layer 1"
      viewBox="0 0 1077.87 813.02"
    >
      <defs>
        <linearGradient
          id="198f78e2-ec49-403a-9acf-506373c5226e"
          x1="975.77"
          x2="975.77"
          y1="484.92"
          y2="87.89"
          gradientTransform="translate(-77.03)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="gray" stopOpacity="0.25"></stop>
          <stop offset="0.54" stopColor="gray" stopOpacity="0.12"></stop>
          <stop offset="1" stopColor="gray" stopOpacity="0.1"></stop>
        </linearGradient>
        <linearGradient
          id="6e777f18-a157-4954-9b1f-a7cbf36b1989"
          x1="649.11"
          x2="649.11"
          y1="832.85"
          y2="382.11"
          xlinkHref="#198f78e2-ec49-403a-9acf-506373c5226e"
        ></linearGradient>
      </defs>
      <path
        fill="#0a80ff"
        d="M724.89 154.84c-46.25 39.26-106.24 36.72-158.81 16.29S465.22 114.34 414 88.49c-42.94-21.67-88-35.9-133.61-42.23-65.28-9.06-138.18 2-183.66 65.44-50.65 70.68-46.76 198.16 8 263 27.87 33 64.36 49.2 96.18 75s61.29 68.56 58.58 118.3c-2.51 46-31.68 81.37-61.87 103.54-23.33 17.13-52.06 35.84-54.87 71.33-2.72 34.33 21.44 61.24 44.51 76.54 75.26 49.91 168 49.43 243-1.26 26.74-18.09 51.3-42.15 79.35-56.23 73.65-37 154.81.24 232.8 13.87 66 11.53 133.69 5.55 198-17.48 38.62-13.83 77.39-35 104.52-74.36 19.57-28.4 31.76-64.35 43.2-99.85q18.3-56.77 35.19-114.36c6.75-23.05 13.4-46.54 15.15-71.19 3.16-44.68-10.16-88.85-28.3-126.55C1067.1 182.47 994.56 119.52 916 103.53s-161.67 15.24-222.6 83.58"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <ellipse
        cx="489.56"
        cy="532.53"
        fill="#0a80ff"
        opacity="0.1"
        rx="226.98"
        ry="10.36"
      ></ellipse>
      <path
        fill="#fff"
        d="M543 533.24c-113.47 0-205.78-92.31-205.78-205.78S429.5 121.68 543 121.68 748.75 214 748.75 327.46 656.43 533.24 543 533.24zm0-409.56c-112.37 0-203.78 91.42-203.78 203.78S430.6 531.24 543 531.24s203.78-91.42 203.78-203.78S655.33 123.68 543 123.68z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#fff"
        d="M543 487.06c-88 0-159.61-71.6-159.61-159.6S455 167.86 543 167.86s159.6 71.6 159.6 159.6S631 487.06 543 487.06zm0-317.2c-86.91 0-157.61 70.7-157.61 157.6s70.7 157.6 157.61 157.6 157.6-70.7 157.6-157.6-70.73-157.6-157.6-157.6z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#fff"
        d="M543 437.46a110 110 0 11110-110 110.13 110.13 0 01-110 110zm0-218a108 108 0 10108 108 108.13 108.13 0 00-108-108z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <ellipse
        cx="979.99"
        cy="403.16"
        fill="#0a80ff"
        opacity="0.1"
        rx="14.27"
        ry="4.72"
      ></ellipse>
      <ellipse
        cx="178.55"
        cy="651.82"
        fill="#0a80ff"
        opacity="0.1"
        rx="84.04"
        ry="13.79"
      ></ellipse>
      <g opacity="0.1">
        <path
          d="M386.93 313.21H130.54a13.44 13.44 0 00-13.4 13.4v162a13.44 13.44 0 0013.4 13.4h201.13s5.21 27.66-11.91 30.64c0 0 38.34 2.75 31.64-30.64h35.53a13.44 13.44 0 0013.4-13.4v-162a13.44 13.44 0 00-13.4-13.4z"
          transform="translate(-61.06 -43.49)"
        ></path>
        <g opacity="0.2">
          <rect
            width="207.7"
            height="12.66"
            x="93.82"
            y="312.72"
            rx="5.67"
            ry="5.67"
          ></rect>
          <rect
            width="207.7"
            height="12.66"
            x="93.82"
            y="369.3"
            rx="5.67"
            ry="5.67"
          ></rect>
          <rect
            width="174.18"
            height="12.66"
            x="93.82"
            y="397.58"
            rx="5.67"
            ry="5.67"
          ></rect>
          <rect
            width="90.06"
            height="12.66"
            x="93.82"
            y="341.01"
            rx="5.67"
            ry="5.67"
          ></rect>
        </g>
      </g>
      <path
        fill="#fff"
        d="M389.17 312.09h-256.4a13.44 13.44 0 00-13.4 13.4v162a13.44 13.44 0 0013.4 13.4H333.9s5.22 27.66-11.91 30.63c0 0 38.34 2.75 31.64-30.63h35.54a13.43 13.43 0 0013.39-13.4v-162a13.43 13.43 0 00-13.39-13.4z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <g fill="#0a80ff" opacity="0.2">
        <rect
          width="207.7"
          height="12.66"
          x="96.06"
          y="311.6"
          rx="5.67"
          ry="5.67"
        ></rect>
        <rect
          width="207.7"
          height="12.66"
          x="96.06"
          y="368.18"
          rx="5.67"
          ry="5.67"
        ></rect>
        <rect
          width="174.18"
          height="12.66"
          x="96.06"
          y="396.47"
          rx="5.67"
          ry="5.67"
        ></rect>
        <rect
          width="90.06"
          height="12.66"
          x="96.06"
          y="339.89"
          rx="5.67"
          ry="5.67"
        ></rect>
      </g>
      <path
        fill="#ffd2c6"
        d="M294 309.52l-14.21 30.22s-2.1 5.67-3.45 6.72-7.32 19-7.32 19L253.79 389l-1 1.6-6-1.65-4.19-15.67.26-4.55v-.57s9.43-9.86 11.52-10.61c0 0 1.64.19 4.79-7.45s6-9.3 6-9.3l1.64-5.54 17.66-28.11s14.8-21.23 18.83-11.81-9.3 14.18-9.3 14.18zM235 524.17a3.4 3.4 0 01-.48 1.45c-1.64 2.39-10.91 51.29-10.91 51.29.74 3.3-1.34 9.88-2.7 12.87s-4.34 18.54-4.34 18.54-.74 33.5-2.68 38.73.62 16.45.62 16.45c-.19 5.16 2.91 10.61 4.75 13.39.14.18.25.36.36.51.6.86 1 1.35 1 1.35a7.79 7.79 0 002.09 2.59c.13.11.27.21.42.32a23.81 23.81 0 008.38 3.54l.29.06c1.2.27 2 .37 2 .37l.74 4-7.92 1.64-15.1 1s-17.8 1.35-13.76-6.58a12.54 12.54 0 00.73-1.68c.15-.38.29-.78.41-1.18 2.43-7.62.79-16.88.79-16.88L196.21 639c-5.67-25.12 4.48-53.09 4.48-53.09s-.89-2.24 1.06-7.92 0-18.09 0-18.09-1-16-2.39-23.93a48.35 48.35 0 01-.54-10.07 50.3 50.3 0 01.54-5.9l34.1-4.52s1.92 5.52 1.54 8.69z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M234.5 689.68l-7.92 1.64-15.1 1s-17.8 1.35-13.76-6.58a12.54 12.54 0 00.73-1.68c.15-.38.29-.78.41-1.18a27.39 27.39 0 019 1.82c5.07 2 8.89-3.15 8.89-3.15l2.46-4.7.36-.68c.6.86 1 1.35 1 1.35a8 8 0 002.51 2.9l-.42.88-2.39 5s3.06.31 7.25 1a3.24 3.24 0 003.94-2.16l.29.06c1.2.27 2 .37 2 .37z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#626696"
        d="M241.83 693.41c-.6 2.69-17.27 3.52-17.27 3.52s-9.28-.9-11.88 1.27-10.26 1.65-10.56 1.65-4.33-.16-5.91-7.4c-1.53-7.06 2.06-8.29 2.24-8.35a27.13 27.13 0 019.43 1.83c5.07 2 8.89-3.14 8.89-3.14l2.82-5.39c.6.86 1 1.35 1 1.35a7.9 7.9 0 002.51 2.91l-2.81 5.91s3.06.31 7.25 1c3.35.54 4.08-2.19 4.23-3.29a3.4 3.4 0 000-.45s2.61.75 5.82 1.65a6 6 0 014.24 6.93z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffd2c6"
        d="M273.24 559.81c-.4 2.39-.81 8.58-.81 8.58 1.4 5.18-2.19 17.49-2.19 17.49l-1.79 7c.8 9-4.93 30.91-4.93 30.91s-3.84 20.34-5.84 29.12a24.21 24.21 0 001 14.66c.1.24.16.36.16.36 0 .17.07.33.12.49s.13.48.21.71a10.8 10.8 0 002 3.34 10.12 10.12 0 001.07 1.1l.06.06a21.64 21.64 0 006.36 3.91l1 .4a30.07 30.07 0 003.17 1 3.29 3.29 0 00.36.08l-.81 4.7-10.56-2.7-14.15-4.59-7-4s.08-.38.22-1.11v-.12c.06-.31.12-.68.21-1.1 1.19-6.1 3.9-23.4 2.54-36.1-1.69-15.75 4.87-37.49 6.47-42.67a25.87 25.87 0 001.2-9.17c-2.6-3.8-3.2-18.94-3.2-18.94s-4.78-9.78-8.74-20.15a53 53 0 01-2.85-10.48 36.65 36.65 0 01-.58-7.66s32.12-29.31 35.64-.93c.12 1 .23 1.88.34 2.78 3.08 25.94 1.7 30.72 1.32 33.03z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M273.24 679.05l-.81 4.7-10.56-2.7-14.15-4.59-7-4s.08-.38.22-1.11v-.12c.06-.31.12-.68.21-1.1l1-.1h.08a13.32 13.32 0 015.93.8c2.3.87 5.32 1.86 5.94 1.44a7.56 7.56 0 013.39-.6l1.47-3.22.21-.49a10.68 10.68 0 002 3.34 11.29 11.29 0 001.13 1.16l-.06 1.14-.08 1.61a20.58 20.58 0 005.08 2.35 2.94 2.94 0 001.42 0l1 .4a30.07 30.07 0 003.17 1 3.29 3.29 0 00.41.09z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#626696"
        d="M268 689.08c-2.95-.85-10.06-2.2-11.21-1.15s-11 0-11 0a6 6 0 01-5.09-3c-2-3.19-.39-13.51-.39-13.51l.73-.07 1.22-.12h.08a13.17 13.17 0 015.93.8c2.3.86 5.32 1.85 5.94 1.44a7.42 7.42 0 013.39-.6l1.68-3.71a10.8 10.8 0 002 3.34 11.29 11.29 0 001.13 1.16l-.14 2.75a20.71 20.71 0 005.08 2.34 2 2 0 002.44-.77 1.51 1.51 0 00.18-.41c.09.17 1.06.5 4.17 1.39 3.38-.19 6.64 1.28 8.14 5.86s-11.39 5.1-14.28 4.26z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M235 524.17c-.66.19-1.26.37-1.82.55a25.23 25.23 0 01-4.41.93c-9.43 1.33-25 .53-29.93.22a50.3 50.3 0 01.54-5.9l34.1-4.52s1.9 5.55 1.52 8.72z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#626696"
        d="M264.72 515.89s-12.52 1.94-22.7 4.17c-3.4.74-6.54 1.51-8.86 2.27a27.21 27.21 0 01-4.41.93c-11.34 1.59-31.48.12-31.48.12-5.53-17.94 6.72-40.53 6.72-40.53-.29-1.8 2.55-7.32 2.55-7.32l.05-.18 1.74-6.4h46.51l.57 2.75 1.18 5.6 7.3 34.67z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M271.92 526.77l-.28.12-5.44 2.41c-5.89 2.72-23.52 3.23-29.68 3.28a36.65 36.65 0 01-.58-7.66s32.12-29.31 35.64-.93c.12 1.01.23 1.88.34 2.78z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#626696"
        d="M272.78 524l-1.14.5-5.44 2.42c-6 2.76-24.19 3.25-30 3.28h-1.53c-2.69-.09-5.38-2.61-5.38-3.27 0-.36-.28-2.13-.52-3.65-.2-1.22-.38-2.27-.38-2.27s-12-5.18-18.09-9.37c-4.57-3.11-3.42-25.21-2.53-36.32.31-3.83.58-6.35.58-6.35l47.08 2.75 6.6.38 3.78.84 1 .21s2.7 19.74 4 21.38.46 7.18.3 10.33a19.19 19.19 0 01-.44 4s1.94 5.54 1.48 8.64a17.23 17.23 0 00.63 6.5z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <circle cx="161.33" cy="297.29" r="19.29" fill="#ffd2c6"></circle>
      <path
        fill="#ffd2c6"
        d="M213 348.83s1.34 18.27-2.39 22.46-13.46 12.11-13.46 12.11l3 12.41 16.9 1.95 19.74-21.09-4.49-5.53s-3.44-11.67-.6-17.5-18.7-4.81-18.7-4.81z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M253.79 389l-1 1.6-6-1.65-4.19-15.67.26-4.55 1.23-1.77s6.58.16 6.29 6.14c-.29 5.25 2.7 13.9 3.41 15.9zM266.8 475.53s-4.76 1.06-10.21 1.77-11.74 1.07-14.32-.43c-4.33-2.56-27.79-1.83-34.52-1.57-.48 0-.86 0-1.16.05l1.74-6.4h46.51l.57 2.75 6.6.38 3.78.84c.63 1.55 1.01 2.61 1.01 2.61z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffcde5"
        d="M242.88 368.15s6.58.15 6.28 6.13 3.59 16.3 3.59 16.3l-1.5 3.44s-2.09 8.37-.45 10.47 7.63 2.09 4.19 19.29c0 0-.74 12.86 1.05 17.05s1.79 14.2 4.48 18.39 6.29 13.91 6.29 13.91-19.45 4.33-24.53 1.34-36.34-1.47-36.34-1.47.15-5.24 0-5.83a5 5 0 01.75-3.82c1-1.42 2.69-3.81 1.79-5.9s2.25-5.18.6-8.42-3.65-3.89-3.25-5.66-.64-4.17-1.83-5.66-9.28-17.3-9.28-17.3l-1.34-7.41s-10.41-7.63-10.22-11.22 3.94-8.56 3.94-8.56l10-9.83s5.53 6 10.91 3.89S225 375.17 225 375.17s4.14-2.24 4.44-3.88 2.84-.15 2.84-.15 3.74-2.05 4.49-1.33 4 1.33 4 1.33z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffd2c6"
        d="M186.35 399.3l-3.19 2.49s-3.24 5.84-4 16.3-4 25.26-4 25.26l-6.28 11.23s-10.35 21.67-11.69 27.42-7.48 15.48-7.48 15.48-20.79 18.68-6.28 22 14.95-14.87 14.95-14.87 3.39-3.74 3.94-6.28 18.94-35.07 18.94-35.07 6.44-8.75 5.09-13.38c0 0 8.37-19.69 8.37-24.63a87.48 87.48 0 00-1.34-12.25l1.34-10.32z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M229.42 440.53s-14.66 7.67-17.5 8.07 12.41-1.6 12.41-1.6zM241.38 446.51s-19.44 6.58-28 5.38c.04 0 21.27 4.04 28-5.38z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M242.58 448.66s-17.5 11-27.82 9.21c0 0 24.08 4.79 27.82 2.25l-10.77-3s11.97-6.32 10.77-8.46zM222.42 306.84c-5.06-1-10.67-.4-14.72 2.78-3 2.36-5 6-8.37 7.72a49.24 49.24 0 01-5.47 1.93 15.78 15.78 0 00-9.63 17c.53 3 1.92 5.7 2.6 8.62 1.22 5.22.15 10.69-1.18 15.88A167.1 167.1 0 01169 402a4.32 4.32 0 00-.83 2.77 4 4 0 001 1.77c6.91 8 18.16 10.73 28.72 11.09 3.89.13 8 0 11.38-1.89a17.2 17.2 0 005.55-5.09 27 27 0 005.18-17.41c-.29-5-2-10.09-.71-14.94a4 4 0 01.9-1.83c1.14-1.16 3-.86 4.64-1.05 4.39-.51 7.23-5.14 7.75-9.52s-.58-8.81-.6-13.22a27.69 27.69 0 015.21-16.28c1.46-2 3.33-4 3.82-6.51.62-3.15-1.21-5.47-2.79-8-2.45-3.88-3.65-8.41-7.38-11.37a19.92 19.92 0 00-8.42-3.68z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#985c7e"
        d="M221.22 305.64c-5.05-1-10.67-.4-14.72 2.79-3 2.35-5 6-8.37 7.72a48.32 48.32 0 01-5.46 1.92 15.79 15.79 0 00-9.64 17c.53 3 1.92 5.7 2.61 8.63 1.22 5.22.14 10.68-1.18 15.87a167.2 167.2 0 01-16.62 41.23 4.23 4.23 0 00-.82 2.76 3.85 3.85 0 001 1.77c6.92 8 18.16 10.73 28.72 11.09 3.89.14 8 0 11.38-1.88a17.24 17.24 0 005.55-5.1 27 27 0 005.15-17.37c-.29-5-2-10.09-.7-14.95a4 4 0 01.89-1.83c1.14-1.16 3-.86 4.65-1 4.39-.51 7.22-5.14 7.74-9.53s-.57-8.8-.6-13.22a27.69 27.69 0 015.2-16.33c1.46-2 3.32-4 3.81-6.52.62-3.15-1.2-5.46-2.78-8-2.45-3.88-3.65-8.41-7.39-11.36a19.82 19.82 0 00-8.42-3.69z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M214.76 492.62s3.84 17.94 10.22 22.83z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <g opacity="0.1">
        <path
          d="M184.17 339.07c-.2-.7-.43-1.4-.67-2.09.2.7.43 1.4.67 2.09zM238.73 323.41a6.49 6.49 0 01-.08 1.69c-.5 2.53-2.36 4.5-3.82 6.52a27.61 27.61 0 00-5.21 16.27c0 4.42 1.11 8.83.59 13.22s-3.35 9-7.74 9.53c-1.62.19-3.51-.12-4.64 1a4 4 0 00-.9 1.83c-1.27 4.86.42 9.94.7 14.95a27 27 0 01-5.14 17.37 17.34 17.34 0 01-5.55 5.1c-3.43 1.85-7.49 2-11.39 1.88-10.38-.35-21.42-3-28.36-10.71a2.74 2.74 0 00-.17 1.44 3.85 3.85 0 001 1.77c6.92 8 18.16 10.73 28.72 11.09 3.89.14 8 0 11.38-1.88a17.34 17.34 0 005.55-5.1 27 27 0 005.15-17.37c-.29-5-2-10.09-.7-14.95a4 4 0 01.89-1.83c1.14-1.16 3-.86 4.65-1 4.39-.51 7.22-5.14 7.74-9.53s-.57-8.8-.6-13.22a27.69 27.69 0 015.2-16.27c1.46-2 3.32-4 3.81-6.52a7.41 7.41 0 00-1.08-5.28z"
          transform="translate(-61.06 -43.49)"
        ></path>
      </g>
      <path
        fill="#0a80ff"
        d="M582.33 807.47s-38.05-2.3-33.56 24.36c0 0-.89 4.71 3.38 6.85 0 0 .07-2 3.9-1.3a17.51 17.51 0 004.13.2 8.63 8.63 0 005.06-2.09s10.69-4.42 14.85-21.9c0 0 3.08-3.81 3-4.79l-6.42 2.74s2.19 4.63.46 8.48c0 0-.2-8.31-1.44-8.11-.25 0-3.33 1.6-3.33 1.6s3.77 8.07.92 13.93c0 0 1.08-9.94-2.1-13.34l-4.52 2.63s4.41 8.34 1.42 15.14c0 0 .77-10.43-2.37-14.49l-4.1 3.19s4.15 8.21 1.62 13.85c0 0-.33-12.14-2.51-13 0 0-3.58 3.15-4.12 4.45 0 0 2.83 6 1.07 9.11 0 0-1.08-8.09-2-8.12 0 0-3.57 5.36-3.94 9a19.48 19.48 0 013.07-9.55 10.71 10.71 0 00-5.46 2.83s.55-3.79 6.34-4.12c0 0 3-4.06 3.74-4.31 0 0-5.76-.48-9.25 1.07 0 0 3.07-3.58 10.31-2l4-3.3s-7.58-1-10.8.11c0 0 3.7-3.17 11.89-.86l4.4-2.64s-6.46-1.39-10.31-.89c0 0 4.06-2.19 11.6.19l3.15-1.42s-4.74-.93-6.12-1.07-1.46-.53-1.46-.53a16.36 16.36 0 018.89 1s6.72-2.48 6.61-2.9z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <ellipse
        cx="495.06"
        cy="797.52"
        fill="#0a80ff"
        opacity="0.1"
        rx="26.93"
        ry="4.55"
      ></ellipse>
      <path
        fill="#0a80ff"
        d="M880.44 774.87s-38-2.29-33.56 24.37c0 0-.89 4.71 3.38 6.85 0 0 .07-2 3.9-1.31a17.62 17.62 0 004.14.2 8.54 8.54 0 005.05-2.09s10.7-4.41 14.85-21.89c0 0 3.08-3.82 3-4.8l-6.46 2.8s2.19 4.63.47 8.48c0 0-.21-8.32-1.44-8.12-.25 0-3.34 1.6-3.34 1.6s3.77 8.07.93 13.94c0 0 1.08-9.94-2.11-13.35l-4.52 2.64s4.41 8.33 1.42 15.13c0 0 .77-10.43-2.37-14.49l-4.09 3.17s4.14 8.22 1.61 13.86c0 0-.33-12.15-2.5-13.06 0 0-3.58 3.16-4.13 4.46 0 0 2.84 6 1.08 9.1 0 0-1.08-8.08-2-8.12 0 0-3.57 5.36-3.94 9a19.45 19.45 0 013.08-9.55 10.76 10.76 0 00-5.47 2.83s.56-3.78 6.35-4.12c0 0 3-4.06 3.74-4.31 0 0-5.76-.48-9.26 1.07 0 0 3.08-3.58 10.31-1.95l4-3.3s-7.59-1-10.8.11c0 0 3.7-3.16 11.89-.86l4.4-2.63s-6.47-1.4-10.32-.89c0 0 4.06-2.19 11.61.18l3.15-1.41s-4.74-.93-6.13-1.08-1.46-.53-1.46-.53a16.39 16.39 0 018.9 1s6.76-2.51 6.64-2.93z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <ellipse
        cx="793.17"
        cy="764.92"
        fill="#0a80ff"
        opacity="0.1"
        rx="26.93"
        ry="4.55"
      ></ellipse>
      <ellipse
        cx="848.09"
        cy="436.83"
        fill="#0a80ff"
        opacity="0.1"
        rx="77.55"
        ry="12.72"
      ></ellipse>
      <path
        fill="url(#198f78e2-ec49-403a-9acf-506373c5226e)"
        d="M999.44 229.49c3.17-10.63 0-21.26 0-21.26v-10s3.62-19.61-12.5-32.19l-10.7-9.43s-6-5.14-7.73-5.47a7.85 7.85 0 00-1-.15l-.32-.18a32.21 32.21 0 01-2.34-4.93 4.57 4.57 0 003.81-1.3 5 5 0 00.9-1.5c.62-1.39.72-3.07 1.25-4.55a10.62 10.62 0 012-3.27c-.11.18-.22.35-.32.53 1.51-1.88 3.49-3.5 4.9-5.49a12 12 0 00.78-1.22l-.21.25c2-3.16 2.57-7 3.14-10.68a9.64 9.64 0 00.06-3.82 12.73 12.73 0 00-1.07-2.42c-2.32-4.8-2.27-10.82-6-14.65-2.79-2.87-7-3.75-11-4.24s-8.17-.77-11.59-2.86a12.55 12.55 0 00-3.14-1.73 2.59 2.59 0 00-3.09 1.15 2 2 0 01-.41.83 1.33 1.33 0 01-1.19.07l-5.3-1.42.06.27h-.13l.19.84c.17 0 .35 0 .5.29l-.85 1.31a13.13 13.13 0 01-4.79-1 2.26 2.26 0 000 .26h-.07c-.1 1.5 1.6 2.47 2.12 3.88a2.94 2.94 0 010 1.9 4.32 4.32 0 01-1 1.52c-1.89 1.86-4.29 1.49-6.46 2.67a1.38 1.38 0 00-.79.87.67.67 0 00-.07.48 1.12 1.12 0 00.44.55 10 10 0 002.06 1.28l-.62.6a23.74 23.74 0 008.2 38.71c.08.41.14.83.2 1.28v.12l.06.57-7.15 3a5.69 5.69 0 01-5.12-3.29c-1.66-3.44-7.53 0-7.53 0s-17.93-1.35-24.56 1.95c0 0-10.7-4.49-12.2-4.79s-3.77-1.5-4.83-1.2-2.41-2-3.16-1.8-1-1.49-3.46-2.09-3.32.15-6-2.55-24.71-13.32-24.71-13.32l-9.94-8.09-10.55-8.38-.19.35c-.06-.25-.13-.51-.2-.78a100 100 0 00-3.91-12.3c-.68-1.62-1-3.67-1.89-2.59-.56.65-1.52-.77-3-1.73a2.49 2.49 0 00-3.72 1.08c-8.21 12.87-11.15 13.8-6.39 18.51 4.23 4.2 7.05 7.91 10.51 9l.41.13a.58.58 0 01-.23 0l20 23.95s14.46 12.58 24.41 16.62 9.19 5.24 9.19 5.24 30.13 15.27 34.8 15 3.77 31.29 1.81 36.38-5.12 41.92-5.12 41.92-3 7.78.15 13.17c0 0 .7 10.32.07 12.79-2.75 4.23-6.66 11.41-7.3 18.8 0 .39-.08.76-.12 1.14a2.59 2.59 0 01-.71.58s.26-.06.67-.2a38 38 0 01-2 9 36.67 36.67 0 00-2.46 13v23.79L881 363s-2.41 11.17 0 13.77a6.33 6.33 0 011.32 4.59 8.5 8.5 0 001.54 5.35 4.06 4.06 0 011 3.44c-.8 2.59 1.18 30.13 1.18 30.13s-.58 7.59-1.38 8S886 437 886 437s-8.14 6.79-6.07 10.39l2.08 3.19-.55.54-.34.34a3.17 3.17 0 00-2.07-.39 77.61 77.61 0 01-8.19 7.29c-3.67 2.65-13.66 6.49-13.66 6.49l-7.88.64h-.15s-3.77-.35-1.66 5.49 21 4 21 4l11-1.74s19.68.09 25.31-1.15c2.36-.53 2.92-1.78 2.77-3.06l-.06-.06a7.86 7.86 0 00-1.61-3.31 1.56 1.56 0 00-.14-.17l.36-4c8.35-4.81-2.36-14.28-2.36-14.28s3.66-8 5.55-10.57 1.88-40.72 1.88-40.72 1-13.78-1.61-17a5.75 5.75 0 012.81-5.19c1.86-1.27 7.48-18.76 11.89-33.28l2.78 17.11s-.6 8.18 1.21 10.58a4.07 4.07 0 01.74 3.18 14.15 14.15 0 00.41 6.93 4.48 4.48 0 001.45 2.46c1.61.8 1.71 3.65 2.31 4.25s4.32-.85 4.52 1.34a48.94 48.94 0 010 5.79l1.21 35.53s-2 3-2.41 10.78c-.17 3.36-.8 5.27-1.45 6.36a3.25 3.25 0 00.3 3.82l.35.4-1.49 1.15a3.25 3.25 0 00-.92 4 3.21 3.21 0 00-.93 3.45 4 4 0 00.26.56 5.63 5.63 0 00-3 1.48 24.6 24.6 0 01-5.3 5.34 99.92 99.92 0 00-8.46 7.24 12.14 12.14 0 01-4.94 4 8 8 0 01-1.49.44c-4 .81-2.71 4.95.5 5.6s13.86 3.94 22.15 2c0 0 2.46 1 6.07-.84s11.83-4 11.83-4 4.52 0 5.12-1.8a6.89 6.89 0 00.26-1.75l.13-.12-.12-.11a23.56 23.56 0 00-.31-4c-.11-.68-.24-1.3-.36-1.79-.39-1.5-1.1-3.43-1.41-4.25a1.53 1.53 0 00.14-.21c1.72-2.91-1.14-10-1.14-10a19.11 19.11 0 013.41-4c1.61-1.19 5.83-32.33 5.83-32.33s-.2-8 2-11.58-3-25.35-3-25.35-2.21-5-1.4-6.79-.81-8.38-.81-8.38v-7.86a8.64 8.64 0 00-.46-2.76c-.62-1.85-1.54-5.4-.54-8 1.41-3.59 4.62-25.75 4.62-25.75s-2.51-9.77 1.16-17.55a16.79 16.79 0 011-1.81c2.72-4.28 1.91-11.88.57-18-.21-.95-.43-1.86-.65-2.73-.1-.37-.2-.72-.29-1.07l.43-.18s0-.59.13-1.58a11 11 0 007.25-5s9.19-10.33 17.33-14.67 8.74-10.63 8.74-10.63c-1.21-2.1 2.15-10.63 2.15-10.63zm-32-78.38zm5.53 92.15l-8.7 10.09a.21.21 0 010-.06c-2.26-3.14 2.11-10.18 2.11-10.18l7.19-16.11c-.06 2.08-.31 3.9-.94 4.76-2 2.7 3.61 7.19 3.61 7.19-3.01-.03-3.31 4.31-3.31 4.31z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#cc818c"
        d="M819.74 111l-4.74 9.21a18.35 18.35 0 01-4.42-.92 16.77 16.77 0 01-10.38-9c-4.24-9.38 2.78-15.44 6.05-17.22s6.3-3.83 8.75 2a101.43 101.43 0 013.86 12.22c.54 2.22.88 3.71.88 3.71zM970.66 159l-7.58 11.31s-35.86 17.1-29-3c3-8.85 3.37-15.33 2.83-19.81v-.12c-.7-5.6-2.81-8-2.81-8s34.95-17.88 29.75-5.65a17 17 0 00-1.24 8.05 27.42 27.42 0 003.77 11.17 37 37 0 004.28 6.05z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#444053"
        d="M959.8 382.79s5.16 21.62 3 25.19-2 11.5-2 11.5-4.17 30.95-5.76 32.14a19 19 0 00-3.37 4s2.83 7 1.13 9.9a2.35 2.35 0 01-1.13 1c-2.66 1.12-12.48-3.85-18.07-6.9a3.08 3.08 0 01-1.48-1.77 3.15 3.15 0 01.91-3.42 3.26 3.26 0 01.91-4l1.47-1.14-.34-.4a3.25 3.25 0 01-.3-3.8c.64-1.08 1.26-3 1.43-6.31.4-7.74 2.38-10.71 2.38-10.71l-1.19-35.31a50.69 50.69 0 000-5.75c-.2-2.18-3.87-.74-4.46-1.34s-.7-3.42-2.28-4.22a4.44 4.44 0 01-1.44-2.44 14.22 14.22 0 01-.41-6.89 4.06 4.06 0 00-.73-3.16c-1.79-2.38-1.19-10.51-1.19-10.51l-2.74-17c-4.36 14.43-9.91 31.81-11.74 33.07a5.72 5.72 0 00-2.78 5.16c2.58 3.17 1.59 16.86 1.59 16.86s0 37.88-1.86 40.46-5.48 10.51-5.48 10.51 10.63 9.46 2.27 14.23l-.09.05c-8.53 4.76-26.18-8.52-26.18-8.52l1.84-1.84.54-.54-2-3.18c-2.05-3.57 6-10.31 6-10.31s-2.14-8.33-1.35-8.73 1.35-7.94 1.35-7.94-1.95-27.37-1.16-29.94a4 4 0 00-.94-3.42 8.54 8.54 0 01-1.52-5.31 6.32 6.32 0 00-1.3-4.56c-2.38-2.58 0-13.69 0-13.69l2-14.68v-23.38a37 37 0 012.4-13.12 39.6 39.6 0 002.16-10.56c.65-7.52 4.69-14.83 7.41-19 1.44-2.2 2.51-3.52 2.51-3.52l63.47-2.49s1 2.83 2 6.76c.22.86.44 1.76.64 2.71 1.33 6.1 2.13 13.65-.56 17.91a14.09 14.09 0 00-1 1.79c-3.63 7.73-1.15 17.44-1.15 17.44s-3.17 22-4.56 25.59c-1 2.53-.08 6.06.54 7.9a8.79 8.79 0 01.45 2.74v7.81s1.59 6.54.8 8.33 1.36 6.75 1.36 6.75z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M962.72 305a16.43 16.43 0 00-1 1.79l-3.57-.2c.34-1.84-2.09-19.09-2.09-19.09l7.2-.41c1.34 6.14 2.15 13.7-.54 17.91z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#444053"
        d="M963.31 304.45a14.09 14.09 0 00-1 1.79l-3.58-.2c.35-1.84-2.08-19.1-2.08-19.1l7.19-.4c1.36 6.1 2.16 13.65-.53 17.91z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M963.31 304.45a14.09 14.09 0 00-1 1.79l-3.58-.2c.35-1.84-2.08-19.1-2.08-19.1l7.19-.4c1.36 6.1 2.16 13.65-.53 17.91z"
        opacity="0.05"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M952.8 465.49a2.35 2.35 0 01-1.13 1c-2.66 1.12-12.48-3.85-18.07-6.9a3.08 3.08 0 01-1.48-1.77c3.18-.58 5.27 3 5.27 3a4.69 4.69 0 016.54 1.59c2.73 4 8.58 2.32 8.58 2.32s.12.27.29.76z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ff748f"
        d="M954.45 477.65c-.6 1.78-5.06 1.78-5.06 1.78s-8 2.29-11.56 4.07-6 .84-6 .84c-8.19 1.89-18.7-1.38-21.87-2s-4.42-4.76-.5-5.55a7.84 7.84 0 001.47-.45 11.94 11.94 0 004.88-4 101.18 101.18 0 018.35-7.2 24.16 24.16 0 005.24-5.3c4.66-4.12 8 1.54 8 1.54a4.69 4.69 0 016.54 1.59c2.73 4 8.58 2.32 8.58 2.32s1 2.68 1.54 4.61c.12.49.25 1.11.36 1.79a15.65 15.65 0 01.03 5.96z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <circle cx="879.75" cy="421.07" r="0.55" fill="#575988"></circle>
      <circle cx="875.09" cy="425.43" r="0.55" fill="#575988"></circle>
      <circle cx="870.35" cy="429.35" r="0.55" fill="#575988"></circle>
      <circle cx="872.8" cy="427.6" r="0.55" fill="#575988"></circle>
      <circle cx="877.52" cy="423.11" r="0.55" fill="#575988"></circle>
      <path
        fill="#dce6f2"
        d="M954.45 477.65c-.6 1.78-5.06 1.78-5.06 1.78s-8 2.29-11.56 4.07-6 .84-6 .84c-8.19 1.89-18.7-1.38-21.87-2s-4.42-4.76-.5-5.55a7.84 7.84 0 001.47-.45 38 38 0 0010.73 2c8.08.34 14.48 0 14.48 0l8.18-2.63a13.69 13.69 0 015.06-1.84 13 13 0 005-2.18 15.65 15.65 0 01.07 5.96z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#575988"
        d="M934.09 482.78a6.75 6.75 0 01-1.36-.14l.12-.58a8.59 8.59 0 004.9-.68c.73-.29 1.46-.63 2.17-1s1.7-.8 2.58-1.13l.81-.28c.45-.15.9-.3 1.33-.49.25-.1.49-.22.73-.33a8.14 8.14 0 011.84-.7 8.55 8.55 0 011-.13 8.51 8.51 0 00.9-.11 7.82 7.82 0 001.72-.64 8.35 8.35 0 011.85-.68l.44-.08a2.11 2.11 0 001.28-.47l.43.41a2.67 2.67 0 01-1.62.65l-.41.07a7.82 7.82 0 00-1.72.64 8.35 8.35 0 01-1.85.68 6.59 6.59 0 01-1 .12 8.73 8.73 0 00-.93.12 7.56 7.56 0 00-1.7.66l-.75.34c-.46.19-.92.35-1.38.5l-.79.28c-.86.32-1.71.72-2.54 1.1s-1.45.69-2.2 1a10.58 10.58 0 01-3.85.87z"
        opacity="0.5"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M936 384.23s4.12-6 11.16-5.9 10.06-.79 10.06-.79-4.51 2.67-7.63 3-13.59 3.69-13.59 3.69zM938.38 385.62s3.72-2.58 5.85-2.68 4-.3 4-.3a11.3 11.3 0 01-3.27 1.59c-1.82.5-6.58 1.39-6.58 1.39zM939.17 387.4s5.61.45 5.66 1.94M887 303.78c.29.05 5.29-5.21 5.64-7.29a5.1 5.1 0 012.18-3.2s3.23 1.29.35 5.24-8.17 5.25-8.17 5.25zM963.82 133.67c-1.14 2.7-2.15 2.9-1.93 5.52a19.88 19.88 0 01-4.54 3.57c-3.55 2.11-7.41 6.23-11.83 6.23a23.45 23.45 0 01-8.64-1.63c-.7-5.6-2.81-8-2.81-8s34.93-17.92 29.75-5.69z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#cc818c"
        d="M969.17 124.15a23.65 23.65 0 11-23.65-23.65 23.64 23.64 0 0123.65 23.65z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M970.66 159l-7.58 11.31s-35.86 17.1-29-3c3-8.85 3.37-15.33 2.83-19.81h.06a18.76 18.76 0 01.71 4.56c.11 3.08.19 7 7.85 8.28 12.77 2.15 19.63-5.84 20.83-7.41a37 37 0 004.3 6.07zM819.74 111l-4.74 9.21a18.35 18.35 0 01-4.42-.92l-.41-.49c1.94.74 8.48-11.61 8.48-11.61l.21.17c.54 2.15.88 3.64.88 3.64zM963.23 283.83c-15.31 6.65-68.29 1-68.29 1a6.68 6.68 0 00.27-1.73c1.44-2.2 2.51-3.52 2.51-3.52l63.47-2.49s1.03 2.81 2.04 6.74z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#67647e"
        d="M937 148.05l-7.06 3a5.64 5.64 0 01-5.06-3.28c-1.63-3.42-7.43 0-7.43 0s-17.71-1.34-24.25 1.94c0 0-10.56-4.47-12-4.76s-3.72-1.49-4.76-1.19-2.38-1.94-3.12-1.79-1.05-1.49-3.43-2.08-3.27.15-5.95-2.53-24.39-13.24-24.39-13.24l-9.82-8-10.41-8.33s-6.55 12.34-8.48 11.6l19.78 23.8s14.28 12.5 24.1 16.51 9.07 5.21 9.07 5.21 29.76 15.17 34.37 14.88 3.72 31.09 1.78 36.15-5.05 41.65-5.05 41.65-3 7.73.14 13.09c0 0 .75 11 0 12.94 0 0 53.31 5.7 68.43-1 0 0 2.23-24.69 0-27.82s2.09-10.11 2.09-10.11l9.45-21.32L998.18 200s3.57-19.49-12.34-32l-10.57-9.37s-5.91-5.11-7.63-5.43-1.09 0-1.09 0-6.9 10-21 7.66c-7.66-1.29-7.74-5.19-7.85-8.28a18.76 18.76 0 00-.7-4.53z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M966.05 228.13s-32.73 1.34-39.27 11.61c0 0 8.48-4 16.06-2.83s23.21-8.78 23.21-8.78zM929.9 264s15.47 1 18.75-2.23 3.28-5.2 3.28-5.2zM969.17 196.6s-13.09 15.47 2.83 22.16zM891.67 166.7s4.76 9.71 7.14 10.36zM875.61 162.53s11.9 10.71 14.13 11.75c0 0-12.35-11.75-14.13-11.75zM923.06 152.27s-11.46 17.1-4 27.52c-.06 0-4.18-12.35 4-27.52z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#cc818c"
        d="M951.93 281.84l-3.5 3.29-.49.46-4.05 3.83c-.3.22-.58.44-.87.64-16.5 11.83-19.81-6.14-19.81-6.14s-7.29 4.76-8.33.89 17-9.37 19.63-9.07a3.48 3.48 0 00.72 0 11.31 11.31 0 003.7-1.31c.27-.14.54-.28.8-.43a29.63 29.63 0 002.67-1.68z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M969.77 124.15a23.65 23.65 0 01-11.56 20.33 13.8 13.8 0 01-.86-1.72c-.85-2-1.37-4.09-2.22-6.07a18.94 18.94 0 00-4-5.79 2.53 2.53 0 00-1-.73 2.87 2.87 0 00-2.17.6 9.82 9.82 0 01-3.3 1.45 3.51 3.51 0 01-3.31-1c-.92-1.1-.79-2.72-.52-4.13.57-3.08 1.54-6.1 1.54-9.23s-1.18-6.51-3.9-8.06c-2.4-1.36-5.38-1-8.05-1.75a8.66 8.66 0 01-1.21-.42 23.66 23.66 0 0140.59 16.52z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#585268"
        d="M927.58 103.87c-.43.23-.9.64-.77 1.12a1.1 1.1 0 00.43.55 10.24 10.24 0 003.74 1.92c2.67.72 5.66.38 8.06 1.75 2.71 1.55 3.91 4.92 3.9 8.05s-1 6.16-1.55 9.23c-.26 1.42-.4 3 .53 4.14a3.53 3.53 0 003.31 1 9.75 9.75 0 003.29-1.44 2.85 2.85 0 012.17-.6 2.64 2.64 0 011.06.72 18.78 18.78 0 014 5.8c.86 2 1.38 4.08 2.22 6.07a9.79 9.79 0 004 4.94 5 5 0 006-.63c1.38-1.52 1.34-3.82 2-5.77 1.18-3.37 4.48-5.49 6.54-8.4 2.32-3.27 3-7.4 3.59-11.36a9.54 9.54 0 00.06-3.8 13.76 13.76 0 00-1.05-2.4c-2.3-4.76-2.25-10.75-5.92-14.56-2.76-2.85-6.94-3.72-10.88-4.2s-8.07-.78-11.45-2.85a12.6 12.6 0 00-3.1-1.72 2.55 2.55 0 00-3.05 1.14 2 2 0 01-.41.83 1.3 1.3 0 01-1.16.07l-5.24-1.41.6 2.64a13.08 13.08 0 01-5.56-1c-.1 1.49 1.58 2.46 2.1 3.85a3.56 3.56 0 01-1 3.63c-1.94 1.89-4.32 1.52-6.46 2.69z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M906.35 459.3l-.21 2.38-.09.05c-8.53 4.76-26.18-8.52-26.18-8.52l1.84-1.84a3.2 3.2 0 01.8 2.48l3.61.2 4.31 4.66s11.67 1.35 14.83.59z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ff748f"
        d="M904.86 472.25c-5.55 1.23-25 1.14-25 1.14L869 475.12s-18.69 1.79-20.77-4 1.63-5.45 1.63-5.45h.14l7.78-.63s9.87-3.82 13.49-6.45a77.82 77.82 0 008.08-7.24s3.25-.63 3.19 3.13l3.61.2 4.31 4.65s11.67 1.36 14.83.6h1.09l-.5 5.75.14.18c.69.89 3.8 5.28-1.16 6.39z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <circle cx="823.66" cy="414.31" r="0.55" fill="#575988"></circle>
      <circle cx="809.68" cy="420.38" r="0.55" fill="#575988"></circle>
      <circle cx="802.48" cy="422.57" r="0.55" fill="#575988"></circle>
      <circle cx="813.35" cy="419.22" r="0.55" fill="#575988"></circle>
      <circle cx="806.07" cy="421.48" r="0.55" fill="#575988"></circle>
      <circle cx="817.06" cy="417.5" r="0.55" fill="#575988"></circle>
      <circle cx="820.73" cy="415.91" r="0.55" fill="#575988"></circle>
      <path
        fill="#dce6f2"
        d="M904.86 472.25c-5.55 1.23-25 1.14-25 1.14L869 475.12s-18.69 1.79-20.77-4 1.63-5.45 1.63-5.45h.14c1.19 1.54 3.58 3.3 8.28 3.38l13.44.55 13.93-1s13-.4 15.17-.84a31.52 31.52 0 005.2-1.91c.69.9 3.8 5.29-1.16 6.4z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#575988"
        d="M870 473.81a8.77 8.77 0 01-2.2-.27l.2-.54a10.79 10.79 0 005.54-.25c.66-.17 1.31-.36 2-.56a22.68 22.68 0 019.65-1.09h.43a91.35 91.35 0 0017.85-.8 6.64 6.64 0 003.82-1.53l.43.42a7.24 7.24 0 01-4.15 1.7 92.71 92.71 0 01-18 .8h-.42a29.2 29.2 0 00-5.91.17 30.71 30.71 0 00-3.55.89c-.66.2-1.32.4-2 .57a14.87 14.87 0 01-3.69.49z"
        opacity="0.5"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M951.93 281.84l-3.5 3.29-8.7-11.13a29.63 29.63 0 002.67-1.68z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#67647e"
        d="M991.34 190.5l6.84 9.52v10s3.13 10.57 0 21.13l.35 9.22s-3.32 8.48-2.13 10.56c0 0-.6 6.25-8.63 10.57S970.66 276 970.66 276s-3.42 6.55-12.64 5.06l-8.78 3.72-10.11-12.94 13.68-7.44s4.76-6.4 7.59-6.1l11.6-13.51s.3-4.31 3.27-4.31c0 0-5.5-4.46-3.57-7.14s.3-14.58.3-14.58z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M978.55 233.93s15.62-.29 17.55 3.72-12.79-5.95-17.55-3.72zM948 284.81a4.1 4.1 0 01-.06.78 5.26 5.26 0 01-4.92 4.47h-.28a5.25 5.25 0 01-5.25-5.25 5.38 5.38 0 01.29-1.71c-2.48-2-2.61-5.58-2.55-7.37a11.31 11.31 0 003.7-1.31 24.6 24.6 0 002.59 5.29 5 5 0 011.22-.15 5.25 5.25 0 015.26 5.25z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#575988"
        d="M939.4 273.26s-3.52.79-3.52 1.43-.79 6.45 3.07 8.83 3.48-3.32 3.48-3.32-3.33-5.11-3.03-6.94z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <circle cx="882.28" cy="241.32" r="5.26" fill="#e4aab4"></circle>
      <circle cx="882.28" cy="241.32" r="4.51" fill="#dce6f2"></circle>
      <path
        d="M922.86 286.84s11.11 9.22 25.39 3.38v4.46s-9.52 6.54-18.15 2.58-7.24-10.42-7.24-10.42z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M922.86 285.65s11.14 9.22 25.39 3.35v4.46s-9.52 6.54-18.15 2.58-7.24-10.39-7.24-10.39z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#444053"
        d="M922.86 285.65s11.14 9.22 25.39 3.35v4.46s-9.52 6.54-18.15 2.58-7.24-10.39-7.24-10.39z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M923.16 285.65s11.11 9.22 25.39 3.38v4.46S939 300 930.4 296.07s-7.24-10.42-7.24-10.42z"
        opacity="0.05"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M888 451.32s14.88 2.73 17.06 3.32-.6 1.64-.6 1.64-13.63-2.43-16.46-4.96zM887.61 443.44c.24 0 10.11-2.78 12.24-7.54M902 386.51s4 5.26 6.58 5.11-4.23-5.31-6.58-5.11zM904.22 395.24s1.68 3.72 4.16 2.53"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M913.59 313.57l10.55 27.82s1.49-17.9-1.66-23.26a9.29 9.29 0 00-8.89-4.56z"
        opacity="0.05"
        transform="translate(-61.06 -43.49)"
      ></path>
      <g opacity="0.1">
        <path
          d="M939.56 93.13l-.09-.4-1.7-.45.19.83a12.18 12.18 0 001.6.02zM934.9 99.82l.18-.16a3.55 3.55 0 001-3.62 4.91 4.91 0 00-.84-1.35 13 13 0 01-2.45-.72c-.1 1.49 1.58 2.45 2.1 3.85a3 3 0 01.01 2zM963 145.55a9.83 9.83 0 01-4-4.94c-.85-2-1.36-4.1-2.22-6.07a18.65 18.65 0 00-4-5.79 2.53 2.53 0 00-1.05-.73 2.84 2.84 0 00-2.17.6 10 10 0 01-3.3 1.45 3.57 3.57 0 01-3.31-1c-.92-1.1-.79-2.72-.52-4.13.58-3.08 1.54-6.11 1.55-9.24s-1.19-6.5-3.91-8c-2.4-1.37-5.38-1-8-1.75a10.16 10.16 0 01-3.74-1.92l-.21-.19a6.39 6.39 0 00-.65.31c-.43.23-.89.64-.77 1.11a1.19 1.19 0 00.44.56 10.3 10.3 0 003.74 1.91c2.67.73 5.65.39 8.05 1.76 2.72 1.54 3.91 4.92 3.91 8s-1 6.16-1.55 9.23c-.27 1.41-.4 3 .52 4.13a3.52 3.52 0 003.31 1 10 10 0 003.3-1.44 2.89 2.89 0 012.17-.61 2.63 2.63 0 011 .73 18.88 18.88 0 014 5.79c.86 2 1.37 4.09 2.22 6.07a9.81 9.81 0 004 5c1.89 1 4.51 1 6-.63a4.72 4.72 0 00.89-1.49 5.1 5.1 0 01-5.7.28zM971.54 138c1.49-1.88 3.44-3.48 4.84-5.46a13.93 13.93 0 00.77-1.22c-1.8 2.29-4.27 4.14-5.61 6.68z"
          transform="translate(-61.06 -43.49)"
        ></path>
      </g>
      <g opacity="0.1">
        <path
          d="M883.29 109.9h-236.6a12.4 12.4 0 00-12.37 12.36v149.49a12.4 12.4 0 0012.37 12.36h185.6s4.81 25.53-11 28.27c0 0 35.38 2.54 29.2-28.27h32.79a12.39 12.39 0 0012.36-12.36V122.26a12.39 12.39 0 00-12.35-12.36z"
          transform="translate(-61.06 -43.49)"
        ></path>
        <g opacity="0.2">
          <rect
            width="191.66"
            height="11.68"
            x="608.09"
            y="106.09"
            rx="5.67"
            ry="5.67"
          ></rect>
          <rect
            width="158.15"
            height="11.68"
            x="608.09"
            y="158.29"
            rx="5.67"
            ry="5.67"
          ></rect>
          <rect
            width="113.85"
            height="11.68"
            x="608.09"
            y="132.19"
            rx="5.67"
            ry="5.67"
          ></rect>
        </g>
      </g>
      <path
        fill="#fff"
        d="M886.38 107.83h-236.6a12.41 12.41 0 00-12.37 12.37v149.49a12.4 12.4 0 0012.37 12.36h185.6s4.81 25.53-11 28.27c0 0 35.38 2.54 29.2-28.27h32.79a12.39 12.39 0 0012.36-12.36V120.2a12.4 12.4 0 00-12.35-12.37z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <g fill="#0a80ff" opacity="0.2">
        <rect
          width="191.66"
          height="11.68"
          x="611.18"
          y="104.02"
          rx="5.67"
          ry="5.67"
        ></rect>
        <rect
          width="158.15"
          height="11.68"
          x="611.18"
          y="156.23"
          rx="5.67"
          ry="5.67"
        ></rect>
        <rect
          width="113.85"
          height="11.68"
          x="611.18"
          y="130.13"
          rx="5.67"
          ry="5.67"
        ></rect>
      </g>
      <path
        fill="#0a80ff"
        d="M142.19 596.48s3.56 4.66-1.65 11.7-9.51 13-7.77 17.37c0 0 7.86-13.07 14.26-13.25s2.2-7.96-4.84-15.82z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M142.19 596.48a5.88 5.88 0 01.72 1.46c6.25 7.34 9.57 14.18 3.57 14.36-5.59.16-12.29 10.15-13.9 12.68 0 .19.12.38.19.57 0 0 7.86-13.07 14.26-13.25s2.2-7.96-4.84-15.82z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffd037"
        d="M148.81 602.42c0 1.64-.18 3-.41 3s-.41-1.33-.41-3 .23-.87.46-.87.36-.77.36.87z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffd037"
        d="M151.09 604.38c-1.44.79-2.7 1.26-2.81 1.06s1-1 2.41-1.78.88-.21 1 0 .84-.06-.6.72z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#0a80ff"
        d="M123.35 596.48s-3.56 4.66 1.65 11.7 9.51 13 7.77 17.37c0 0-7.86-13.07-14.26-13.25s-2.2-7.96 4.84-15.82z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M123.35 596.48a5.88 5.88 0 00-.72 1.46c-6.25 7.34-9.57 14.18-3.57 14.36 5.59.16 12.29 10.15 13.9 12.68-.05.19-.12.38-.19.57 0 0-7.86-13.07-14.26-13.25s-2.2-7.96 4.84-15.82z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffd037"
        d="M116.73 602.42c0 1.64.18 3 .41 3s.41-1.33.41-3-.23-.87-.46-.87-.36-.77-.36.87z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffd037"
        d="M114.45 604.38c1.44.79 2.7 1.26 2.81 1.06s-1-1-2.41-1.78-.88-.21-1 0-.85-.06.6.72z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <ellipse
        cx="71.71"
        cy="612.01"
        fill="#0a80ff"
        opacity="0.1"
        rx="37.28"
        ry="5.72"
      ></ellipse>
      <path
        fill="#65617d"
        d="M152 619.27l-.18 1.45-.25 2.06-.11.86-.25 2.05-.1.86-.25 2.06L148 652c-.25 2.09-3.66 3.72-7.78 3.72h-14.86c-4.12 0-7.52-1.63-7.78-3.72l-2.86-23.38-.25-2.06-.1-.86-.25-2.05-.11-.86-.25-2.06-.18-1.45c-.14-1.18 1.71-2.18 4-2.18h30.31c2.36-.01 4.21.99 4.11 2.17z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#9d9cb5"
        d="M90.71 577.23L90.46 579.29 52.95 579.29 52.7 577.23 90.71 577.23z"
      ></path>
      <path
        fill="#9d9cb5"
        d="M90.36 580.15L90.11 582.2 53.31 582.2 53.05 580.15 90.36 580.15z"
      ></path>
      <path
        fill="#9d9cb5"
        d="M90 583.06L89.75 585.12 53.66 585.12 53.41 583.06 90 583.06z"
      ></path>
      <ellipse
        cx="645.79"
        cy="789.35"
        fill="#0a80ff"
        opacity="0.1"
        rx="84.04"
        ry="13.79"
      ></ellipse>
      <g opacity="0.1">
        <path
          d="M804.19 409.36H547.8a13.44 13.44 0 00-13.4 13.4v162a13.44 13.44 0 0013.4 13.4h201.13s5.21 27.66-11.91 30.63c0 0 38.33 2.75 31.63-30.63h35.54a13.44 13.44 0 0013.4-13.4v-162a13.44 13.44 0 00-13.4-13.4z"
          transform="translate(-61.06 -43.49)"
        ></path>
        <g opacity="0.2">
          <rect
            width="207.7"
            height="12.66"
            x="511.08"
            y="465.45"
            rx="5.67"
            ry="5.67"
          ></rect>
          <rect
            width="90.06"
            height="12.66"
            x="511.08"
            y="437.16"
            rx="5.67"
            ry="5.67"
          ></rect>
        </g>
      </g>
      <path
        fill="#fff"
        d="M802 407.13H545.56a13.44 13.44 0 00-13.4 13.4v162a13.44 13.44 0 0013.4 13.4h201.13s5.21 27.66-11.91 30.64c0 0 38.34 2.75 31.64-30.64H802a13.44 13.44 0 0013.4-13.4v-162a13.44 13.44 0 00-13.4-13.4z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <g fill="#0a80ff" opacity="0.2">
        <rect
          width="207.7"
          height="12.66"
          x="508.85"
          y="463.22"
          rx="5.67"
          ry="5.67"
        ></rect>
        <rect
          width="90.06"
          height="12.66"
          x="508.85"
          y="434.93"
          rx="5.67"
          ry="5.67"
        ></rect>
      </g>
      <path
        fill="url(#6e777f18-a157-4954-9b1f-a7cbf36b1989)"
        d="M755.21 823.46c-1.21-5.13-2-9.64-2-9.64s.28-5.59-2.23-9.79V792.3a34.65 34.65 0 012.61-5.41c1.86-3.25 0-15.15 0-15.15s-6.9-16.78-5.22-27.42-14.17-47.27-14.17-47.27a46.49 46.49 0 011.49-10.46 8.09 8.09 0 00.2-2.19 2.35 2.35 0 000-.27v.09c-.24-7-5.79-20.18-5.79-20.18l.75-25.07s3.54-14.79-2.24-34.64c-2-6.92-3.31-12.47-4.13-16.74-.09-.49-.18-1-.26-1.4 11.9-1.81 21-3.32 21-3.32S738.34 554 733.68 549s-8.38-21-8.38-21-2.43-20.39 1.49-26.34 4.47-16.23 4.47-16.23 9-6.5 10.07-9.38 3-9.38 3-12.81-1.12-6.5-.75-8.3-2.61-8.66-1.12-11.91a8.75 8.75 0 00.6-3.13v-.09a44.22 44.22 0 00-.79-8.46 24 24 0 00-8.85-4.73l-.2-.78-.5-2c-.3-.2-.59-.37-.88-.53v-.74l-.09-2.93 1.41-6.58c2.75-11.46-12.54-13.17-12.54-13.17a8 8 0 00-4.33-3.79c-3.08-1.08-.51 17.23.93 18.4 1.08.88 4.42 6.62 6 9.44l.26.47a5.61 5.61 0 00-.7.73l.58 4 .09.61a16.66 16.66 0 00-2.44 4.16s2.8 3.07 2.24 6.5.85 7.7.92 7.93c-.16-.19-2.13-2.32-4.09-1.8s-7.46 2.17-7.46 2.17-4.1.72-3.72 1.62-2.8 4.87-2.8 4.87l-11-10.44c-.1-.31-.22-.62-.32-.95a26.19 26.19 0 01-1-4.57 26.15 26.15 0 003.52-1.12 7.62 7.62 0 003-1.95c1.11-1.32 1.32-3.11 1.77-4.75.88-3.21 2.75-6.07 4.09-9.12a29.6 29.6 0 002.2-16.37 10.81 10.81 0 00-1.69-4.79c-1.8-2.48-5.06-3.48-7.44-5.46s-3.9-5-6.66-6.47c-2.5-1.34-5.55-1.18-8.37-.72a45.09 45.09 0 00-15.61 5.68c-1.61.95-3.37 2.05-5.22 1.72-1.58-.29-2.74-1.56-3.77-2.77 0-.05 0-.1.05-.15l-.12-.14a19.37 19.37 0 00-1.63 8.17c0 .44 0 .88.05 1.32V403.16a2 2 0 01-.08.59 4.3 4.3 0 01-1 1.49 7.84 7.84 0 00-.9 1.22 4 4 0 01.15-.45 6.55 6.55 0 00-1.14 3.48 3.44 3.44 0 00.82 2.48 12 12 0 001.8 1.45 21 21 0 0010 21.84c.13.31.26.63.38.95 1.41 3.71 2.47 8 2 12 0 .3-.08.59-.14.88s-.27.3-.39.46-18.19.18-22.48-3.7-10.81 9.47-10.81 9.47-6.52 1.26-7.82 0-8.95-.18-8.95-.18a16.45 16.45 0 00-11.32-4.14 33.64 33.64 0 00-8.34-4.64l-.2-.07a9.38 9.38 0 00-4.1-.52s-8.95-7.4-11.56-11.36-15-18.69-15.09-18.76v-.71l-.14-2.15a7.11 7.11 0 01-1.11.1c-.07-.21-.15-.46-.25-.74a41.55 41.55 0 00-2.64-6.07s0-2.7.79-3.38-.33-10.6-.33-10.6-8.06-18.85-15.28-4.78c0 0-13.65 9.11-2.19 19.71 0 0 4.57 2.21 5.21 4 .43 1.14 2 4.32 3 6.43l.47.95-.13.11.17 1.77.07.68c-2.16 1.23-3.62 2.44-3.27 3.36a20.34 20.34 0 011.31 4.87s15.78 19.8 17.83 28.3c0 0 42.49 25.25 56.47 27.05l-2.42 12.63a101 101 0 00-.56 10.28c.18 2.71-1.68 15-1.68 15s-2.42 18-4.47 20.56-1.63 13.33-1.63 13.33a91.14 91.14 0 01-2.8 15.33c-2 6.86-.56 15.34-.56 15.34s-7.08 16.23 9.88 5.23c0 0 8.33-.52 17.92-.85v1c0 1.23 0 2.57-.06 4-.13 9.3-.18 22.11.24 31.81.75 17.13 6 51.05 6 51.05v17a23.4 23.4 0 00-.49 4.87 31.75 31.75 0 004.59 17.06l1.31 11.36s3.06 7.49 3.12 12a6.93 6.93 0 01-.13 1.09 7.76 7.76 0 00-.15 1.74c-.17 5.16 2.94 17.5 2.94 17.5s.18 12.45 2 13.17c1.59.62-2.13 7.18-3.24 9.06 0-.12 0-.24-.07-.36l-.23.38a8.72 8.72 0 00-.58 3.14 4.53 4.53 0 002.07 4.38c3.54 2.16 5.44 4 2.43 4.69a32.28 32.28 0 00-3.28.69l-.16-.42a2 2 0 00-1.22 2.18 9.08 9.08 0 001.11 4.22c3 6.68 5 9.2 5 9.2l1.44-.16a7.71 7.71 0 01-.83 1.54 5.94 5.94 0 01-2.11 1.87 6.36 6.36 0 01-2.55.87 7.21 7.21 0 00-5.28 2.57c-1.86 2.41-3 5.68.65 8.56l13.33 4.6s22.92 3 21.71-2.17-2-9.65-2-9.65a20.32 20.32 0 00-1.86-9.12 12.23 12.23 0 00-.81-1.34l.81-.09s1.68-11.37 3.91-13.53c.52-.5.64-.88.51-1.18.23-.62-.35-1-1.1-1.19l-.16.45a10.91 10.91 0 00-2.23-.25s-.74-5.95 1.68-8.11a2.3 2.3 0 00.47-1.77 9.94 9.94 0 00-.25-2.43l-.09.14c-1.22-5.4-5.35-14-5.35-14s-.19-5.41 1.31-7.58-.19-29.4-.19-29.4.56-13.17-1.12-19.3 2.05-13.35 2.05-13.35v-.4l.05-.09s-.09-.81-.22-2.07v.12c-.38-3.48-1.09-9.8-1.61-12.72-.75-4.15.18-24 .18-24l3.36-8.48 6 14.62 6.34 19.48s3.14 4.11 3.21 8.28a4.08 4.08 0 010 .61 11.75 11.75 0 00-.07 1.31 11.54 11.54 0 001.93 6.93s1.68 9.2 4.29 11.55 2.61 6.85 2.61 6.85 3.16 13.35 4.66 15.7c1.25 2 1.32 7.41 1.31 9.07v.49s.44 4.77.42 8.78v1.43a.43.43 0 010-.11 14.65 14.65 0 01-.39 3.25s0 .12-.06.19l.06-.68a34.37 34.37 0 00-1 8.32c-.09 4.8.64 10.48 3.55 13.81 5 5.78 8.2 5.06 8.2 5.06s-2.42 7.21-5.41 8.65a1.69 1.69 0 00-.31.21c0-.14-.06-.28-.08-.42a3.5 3.5 0 00-.87 2.69c-.22 3.17 1.78 8.32 3.69 10.69a5.82 5.82 0 002.52 1.47l-.47.29a10.25 10.25 0 01-1 .49 4.83 4.83 0 01-1.52.39 7.14 7.14 0 00-5.28 2.57c-1.86 2.4-3 5.67.65 8.55l13.33 4.6s22.77 2.94 21.56-2.21z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#2d293d"
        d="M667.65 832l-12.9-4.6c-3.56-2.88-2.42-6.15-.63-8.56a6.9 6.9 0 015.11-2.57 6 6 0 002.47-.87 5.79 5.79 0 002-1.87 9.43 9.43 0 001.47-5s14.17-4.15 18 0a10.66 10.66 0 011.72 2.51 21 21 0 011.8 9.12s.73 4.51 1.89 9.65-20.93 2.19-20.93 2.19zM730.79 825.63l-12.9-4.6c-3.56-2.88-2.43-6.15-.63-8.55a6.83 6.83 0 015.11-2.57 4.53 4.53 0 001.47-.39 7.58 7.58 0 001-.49c3.6-2 3.51-6.85 3.51-6.85s14.16-4.15 18 0a9.67 9.67 0 011.35 1.84c2.44 4.2 2.17 9.8 2.17 9.8s.72 4.51 1.89 9.65-20.97 2.16-20.97 2.16z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M683.25 808.54a10.66 10.66 0 011.72 2.51l-21.23 2.46a9.43 9.43 0 001.47-5s14.17-4.12 18.04.03zM747.74 804v4c-3.29 5.44-19.26 4.25-23.9 1.52a7.58 7.58 0 001-.49c3.6-2 3.51-6.85 3.51-6.85s14.16-4.15 18 0a9.67 9.67 0 011.39 1.82z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#575988"
        d="M750.27 786.89a36.78 36.78 0 00-2.53 5.41v14.25c-3.6 6-22.36 4-24.89.72s-5.23-11.72-2.34-13.16 5.23-8.66 5.23-8.66-3.07.72-7.94-5.05-3.43-18.58-2.52-21.65 0-13.35 0-13.35.18-7.21-1.27-9.56-4.51-15.69-4.51-15.69 0-4.51-2.52-6.86-4.15-11.54-4.15-11.54A11.85 11.85 0 01701 694c.55-4.51-3.06-9.38-3.06-9.38l-6.13-19.48-5.78-14.61-3.22 8.47s-.91 19.84-.18 24 1.8 15.15 1.8 15.15-3.61 7.22-2 13.35 1.08 19.3 1.08 19.3 1.62 27.24.18 29.4-1.26 7.58-1.26 7.58 7.39 15.87 5 18-1.63 8.12-1.63 8.12 5 0 2.89 2.16-3.69 13.56-3.69 13.56l-21.81 2.52s-2-2.52-4.89-9.2.54-6 3.45-6.67 1.06-2.53-2.36-4.69-1.45-7-1.45-7 5.23-8.84 3.43-9.57-2-13.16-2-13.16-3.61-14.8-2.71-18.76-2.89-13.53-2.89-13.53l-1.26-11.37a31.27 31.27 0 01-4-21.46V679.2s-5-33.91-5.77-51.05c-.46-11-.33-25.95-.18-35.3.09-5.24.18-8.71.18-8.71l77.95-8.14a64.36 64.36 0 001.41 11.57c.79 4.28 2 9.82 4 16.75 5.59 19.84 2.16 34.63 2.16 34.63l-.72 25.08s6.86 16.77 5.41 22.55a48 48 0 00-1.44 10.46s15.33 36.62 13.71 47.26 5 27.42 5 27.42 1.85 11.92.05 15.17z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M705.71 692.91l23.73-3.16s-13.44 13.71-23.73 3.16z"
        opacity="0.05"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M726 666.57s.81 8.39-4.33 11.55c.01 0 9.21-1.45 4.33-11.55zM724.55 639.88s-19.83 16.32-27 15 27-15 27-15zM676.31 700.58s-15.06 3.42-15.51 9.47 15.51-9.47 15.51-9.47z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M679.62 775.8s-21.28 4-15.24 6.67 16 4.87 16 4.87 6.82.36-.76-11.54z"
        opacity="0.05"
        transform="translate(-61.06 -43.49)"
      ></path>
      <g opacity="0.05">
        <path
          d="M660.08 786.77a4.24 4.24 0 01-1.94-3.09l-.22.38s-2 4.87 1.44 7c.4.25.77.5 1.11.74.64-.12 1.32-.21 2-.37 2.88-.7 1.04-2.5-2.39-4.66zM687.5 785.32c.59-.54.57-1.93.21-3.71a10.06 10.06 0 00-1.21 5.23 4.38 4.38 0 011-1.52zM684.23 695.58a24.26 24.26 0 00-1.44 6.63 26.12 26.12 0 011.65-4.56s-.08-.81-.21-2.07zM733 686.11a8.3 8.3 0 00.2-2c-.27 1.34-.46 2.59-.59 3.69.07-.53.2-1.1.39-1.69zM683.71 759.71a11.5 11.5 0 00.54-4 13.59 13.59 0 00-1 5.06 4.88 4.88 0 01.46-1.06zM688.18 793.72a71 71 0 00-2.48 11.08l-21.81 2.53s-2-2.53-4.89-9.2c-.25-.59-.45-1.11-.61-1.59-1.31.6-1.82 2-.11 5.92 2.89 6.67 4.88 9.2 4.88 9.2l21.84-2.53s1.62-11.36 3.78-13.53c1.05-1.06.37-1.6-.6-1.88zM659.36 761.33s.18 12.45 2 13.17c.91-2.06 1.52-4 .71-4.34-1.81-.72-2-13.17-2-13.17s-3.6-14.79-2.7-18.76-2.89-13.53-2.89-13.53l-1.26-11.36a31.23 31.23 0 01-4-21.47v-17.5s-5-33.91-5.77-51c-.46-11-.33-26-.18-35.3 0-1.69.05-3.19.08-4.45l-.62.06s-.1 3.47-.18 8.72c-.16 9.34-.29 24.32.18 35.29.72 17.14 5.77 51.05 5.77 51.05v17.5a31.23 31.23 0 004 21.47l1.27 11.29s3.79 9.56 2.89 13.53 2.7 18.8 2.7 18.8zM723.58 802.46a21 21 0 01-3.45-8.57c-2.23 2 .33 9.81 2.73 12.9 2.52 3.24 21.28 5.23 24.89-.72v-3.44c-4.88 4.84-21.75 2.9-24.17-.17zM751 782.08a35 35 0 00-2.53 5.41V790c.41-.93 1-2.16 1.81-3.62a10.79 10.79 0 00.79-4.46.61.61 0 00-.07.16zM724.69 784.92a34.82 34.82 0 001.78-4.29s-3.07.72-7.94-5c-3.55-4.2-3.75-12.13-3.24-17.31-.91 3.06-2.35 15.87 2.52 21.64 3.19 3.73 5.59 4.72 6.88 4.96zM715.28 744.92a96.4 96.4 0 01.36 10.69 15.59 15.59 0 01.37-1.68c.91-3.06 0-13.34 0-13.34s.18-7.22-1.26-9.56-4.51-15.7-4.51-15.7 0-4.51-2.52-6.85-4.15-11.55-4.15-11.55a11.81 11.81 0 01-1.81-7.75c.54-4.51-3.06-9.38-3.06-9.38l-6.14-19.49-5.77-14.61-3.25 8.48s0 1.07-.11 2.74l2.64-6.89 5.77 14.61 6.16 19.49s3.61 4.87 3.07 9.38a11.81 11.81 0 001.81 7.75s1.62 9.2 4.14 11.55 2.53 6.85 2.53 6.85 3.07 13.35 4.51 15.7 1.22 9.56 1.22 9.56z"
          transform="translate(-61.06 -43.49)"
        ></path>
      </g>
      <path
        fill="#ffcdd3"
        d="M730.43 413l-1.36 6.58.08 2.93.06 2.17-7.53.77-.84-1.56c-1.56-2.82-4.79-8.56-5.84-9.44-1.39-1.17-3.87-19.48-.89-18.4a7.88 7.88 0 014.19 3.8s14.79 1.74 12.13 13.15z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M729.21 424.72l-7.53.77-.84-1.56a6.65 6.65 0 018.31-1.37z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#dce6f2"
        d="M731.11 428.28l-9.93 2.3-.2-1.48-.57-4s3.93-5.24 9.61-1.31l.49 2z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffcdd3"
        d="M570.33 413.76l-10.59 5.68-1-2c-1-2.11-2.51-5.29-2.92-6.43-.63-1.75-5.05-4-5.05-4-11.09-10.6 2.12-19.71 2.12-19.71 7-14.07 14.79 4.78 14.79 4.78s1.08 9.93.32 10.6-.77 3.38-.77 3.38a41.06 41.06 0 012.56 6.07c.37 1.01.54 1.63.54 1.63z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M570.33 413.76l-10.59 5.68-1-2c1.49-1.24 6.8-5.54 8.54-5.35a13.32 13.32 0 002.51.07c.37.98.54 1.6.54 1.6z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#dce6f2"
        d="M571.41 417l-11.9 5.87-.24-2.56-.17-1.77s6.9-5.91 8.94-5.69a10.76 10.76 0 003.11 0l.13 2.14z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffcdd3"
        d="M701.57 456.78s-51.92 5.86-42.21 2.71c6.75-2.2 9.43-6.49 10-11.26.45-4-.57-8.3-1.94-12a51.64 51.64 0 00-4.64-9.38s39.69-21.83 31.75-2a31.8 31.8 0 00-2.25 9.4 26.28 26.28 0 001 9.51 28.27 28.27 0 008.29 13.02z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M694.53 424.86a31.8 31.8 0 00-2.25 9.4c-3.74 3.14-7.84 2.93-13.1 2.93-4 0-8.52 1-11.76-1a51.64 51.64 0 00-4.64-9.38s39.69-21.81 31.75-1.95z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <circle cx="617.41" cy="373.61" r="21.47" fill="#ffcdd3"></circle>
      <path
        d="M701.57 456.78s-51.92 5.86-42.21 2.71c6.75-2.2 9.43-6.49 10-11.26 2.58-2.8 7.77-4.82 11.11-5.89a15.51 15.51 0 019.41-.15 13.07 13.07 0 013.42 1.58 28.27 28.27 0 008.27 13.01zM731.11 428.28l-9.93 2.3-.2-1.48a8.77 8.77 0 019.53-3.26zM571.41 417l-11.9 5.87-.24-2.56a87.48 87.48 0 0112-5.32zM722.1 587.59c-20.1 3.18-48.72 7.31-53.26 5.93-3.76-1.15-15.79-1-26.26-.67.09-5.24.18-8.71.18-8.71l77.93-8.14a64.36 64.36 0 001.41 11.59z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#656691"
        d="M742.15 582.87s-66.2 11.37-73.31 9.2-43.58.18-43.58.18c-16.41 11-9.56-5.23-9.56-5.23s-1.44-8.48.54-15.33a93.37 93.37 0 002.76-15.33s-.36-10.83 1.62-13.35 4.33-20.57 4.33-20.57 1.81-12.26 1.63-15a102.58 102.58 0 01.54-10.28l2.34-12.63c-13.53-1.8-54.66-27.06-54.66-27.06-2-8.47-17.31-28.32-17.31-28.32a20.6 20.6 0 00-1.27-4.87c-1.08-2.88 15.16-8.65 15.16-8.65s12.08 14.79 14.61 18.76 11.18 11.36 11.18 11.36a8.8 8.8 0 014 .52l.21.06a32.34 32.34 0 018.08 4.64 15.66 15.66 0 0111 4.15s7.4-1.08 8.66.18 7.58 0 7.58 0 6.31-13.35 10.46-9.47 21.75 3.7 21.75 3.7c2.35-3.12 8.06-5.36 11.63-6.51a15.58 15.58 0 019.41-.15 12.13 12.13 0 013.71 1.79l10.68 10.46s3.07-4 2.71-4.87 3.61-1.62 3.61-1.62 5.23-1.63 7.21-2.17 3.8 1.61 4 1.8c-.06-.23-1.42-4.6-.89-7.93s-2.17-6.5-2.17-6.5c6.32-15.51 20.57-2.52 20.57-2.52s1.62 8.48.18 11.72 1.44 10.11 1.08 11.91.72 4.87.72 8.3-1.8 9.92-2.89 12.8-9.74 9.38-9.74 9.38-.54 10.29-4.33 16.24-1.55 26.34-1.55 26.34 3.61 15.91 8.15 21 11.15 33.87 11.15 33.87z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M645.65 464.18s-2-5.95-3.79-6.49a42.93 42.93 0 01-5.23-2.35l1.16-2.22s6.77 1.86 7.86 3.84 0 7.22 0 7.22zM609.39 451c-.36 1.8-16.42 3.43-16.42 3.43l8.12-8.14.2.07a32.34 32.34 0 018.1 4.64z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <circle cx="501.87" cy="382.76" r="1.44" fill="#575988"></circle>
      <circle cx="503.72" cy="385.65" r="1.44" fill="#575988"></circle>
      <circle cx="505.53" cy="388.31" r="1.44" fill="#575988"></circle>
      <circle cx="507.42" cy="391.2" r="1.44" fill="#575988"></circle>
      <circle cx="677.46" cy="391.04" r="1.17" fill="#575988"></circle>
      <circle cx="677.64" cy="393.7" r="1.17" fill="#575988"></circle>
      <circle cx="677.8" cy="396.36" r="1.17" fill="#575988"></circle>
      <path
        d="M645.74 513.06c-.17-.21 40.49 51.14 72.06 21.47 0 0-49.88 6.76-72.06-21.47zM622.38 539.76s24.33.66 26.87 7.66v7.29a4.65 4.65 0 01-4.52 0c-2.45-1.33-17.17-8.8-22.35-5.21z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#656691"
        d="M622.83 539.76s23.27.63 25.7 7.31V554a4.46 4.46 0 01-4.33 0c-2.34-1.26-16.41-8.39-21.37-5z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M635.66 486.92a78.61 78.61 0 009.43 16.19 63.48 63.48 0 0014.78 14.27s-23.81-27.11-24.21-30.46zM627.7 458.65s4.06 17.52 14.52 23.48zM621.47 460.42c-.1-.32-3.6 13.86 13.49 21.71.04 0-7.26-2.47-13.49-21.71zM727.72 448.67c-.27 0 8.44 5.54 10.8 8.11 0 0-5.66-8.47-10.8-8.11z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#2d293d"
        d="M672.67 436.56a4.57 4.57 0 001.68 2.9 4.63 4.63 0 002 .45c6.55.4 13.36.69 19.41-1.83a7.34 7.34 0 003-1.95c1.08-1.32 1.28-3.11 1.72-4.75.84-3.21 2.65-6.07 4-9.12a30.59 30.59 0 002.12-16.37 10.85 10.85 0 00-1.63-4.79c-1.74-2.48-4.9-3.48-7.2-5.45s-3.77-5-6.45-6.48c-2.42-1.34-5.37-1.18-8.1-.72a42.74 42.74 0 00-15.22 5.68c-1.55.95-3.26 2.05-5 1.72-1.57-.3-2.71-1.62-3.72-2.85a20 20 0 00-1.6 9.35 4.16 4.16 0 010 1.41 4.35 4.35 0 01-1 1.49c-1.62 1.87-2.63 4.84-1 6.73.69.83 1.76 1.28 2.44 2.12 1.21 1.51.8 3.67.77 5.61a2.86 2.86 0 00.48 1.9 2.77 2.77 0 002.65.63 7.35 7.35 0 012.82-.27 4.64 4.64 0 012.45 1.89c2.94 3.84 4.11 8.07 5.38 12.7z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <g opacity="0.1">
        <path
          d="M699.45 434.47a7.26 7.26 0 01-3 2c-6 2.52-12.86 2.23-19.41 1.82a4.36 4.36 0 01-2-.45 4.54 4.54 0 01-1.68-2.9c-1.27-4.62-2.44-8.85-5.47-12.69a4.64 4.64 0 00-2.45-1.89 7.16 7.16 0 00-2.82.27A2.79 2.79 0 01660 420a2.88 2.88 0 01-.48-1.91c0-1.93.44-4.1-.77-5.6-.68-.85-1.74-1.29-2.44-2.12a4.24 4.24 0 01-.42-4.31c-1.14 1.82-1.64 4.16-.3 5.75.69.83 1.76 1.28 2.44 2.12 1.21 1.51.8 3.67.77 5.61a2.86 2.86 0 00.48 1.9 2.77 2.77 0 002.65.63 7.35 7.35 0 012.82-.27 4.64 4.64 0 012.45 1.89c3 3.84 4.2 8.07 5.47 12.7a3.39 3.39 0 003.7 3.35c6.55.4 13.36.69 19.41-1.83a7.34 7.34 0 003-1.95 5.73 5.73 0 00.93-1.74 3.06 3.06 0 01-.26.25zM657.68 403.19a3 3 0 00.66-1.08 4.17 4.17 0 000-1.41 19.9 19.9 0 011-7.77l-.12-.14a19.86 19.86 0 00-1.6 9.35 6.15 6.15 0 01.06 1.05z"
          transform="translate(-61.06 -43.49)"
        ></path>
      </g>
      <path
        d="M668.84 449.57s26.82 3.55 29.23-.48M721 438.47s14.89 0 18.17 5.61"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#0a80ff"
        d="M1041.74 425s1.86 2.43-.86 6.11-5 6.79-4.06 9.08c0 0 4.11-6.83 7.45-6.93s1.15-4.2-2.53-8.26z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M1041.74 425a3.29 3.29 0 01.38.76c3.26 3.84 5 7.41 1.86 7.5-2.92.09-6.42 5.31-7.26 6.63 0 .1.06.2.1.3s4.11-6.83 7.45-6.93 1.15-4.2-2.53-8.26z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffd037"
        d="M1045.2 428.05c0 .86-.09 1.56-.21 1.56s-.22-.7-.22-1.56.12-.45.24-.45.19-.4.19.45z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffd037"
        d="M1046.39 429.08c-.75.41-1.41.66-1.46.55s.5-.52 1.26-.93.45-.11.51 0 .45-.03-.31.38z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#0a80ff"
        d="M1031.9 425s-1.87 2.43.86 6.11 5 6.79 4.06 9.08c0 0-4.11-6.83-7.46-6.93s-1.14-4.2 2.54-8.26z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M1031.9 425a3.05 3.05 0 00-.39.76c-3.26 3.84-5 7.41-1.86 7.5 2.92.09 6.43 5.31 7.27 6.63 0 .1-.06.2-.1.3s-4.11-6.83-7.46-6.93-1.14-4.2 2.54-8.26z"
        opacity="0.1"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffd037"
        d="M1028.43 428.05c0 .86.1 1.56.22 1.56a3.16 3.16 0 00.21-1.56c0-.85-.12-.45-.24-.45s-.19-.4-.19.45z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#ffd037"
        d="M1027.24 429.08c.76.41 1.41.66 1.47.55s-.51-.52-1.26-.93-.46-.11-.52 0-.44-.03.31.38z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        fill="#a8a8a8"
        d="M1029 439.82s5.21-.16 6.78-1.28 8-2.45 8.41-.66 7.83 8.92 2 9-13.67-.91-15.24-1.87-1.95-5.19-1.95-5.19z"
        transform="translate(-61.06 -43.49)"
      ></path>
      <path
        d="M1046.26 446.23c-5.88 0-13.67-.92-15.23-1.87-1.2-.73-1.67-3.34-1.83-4.54h-.2s.33 4.21 1.9 5.16 9.35 1.92 15.24 1.87c1.7 0 2.28-.62 2.25-1.51-.22.54-.86.88-2.13.89z"
        opacity="0.2"
        transform="translate(-61.06 -43.49)"
      ></path>
    </svg>
  );
}

export default NoMessages;
